export default __webpack_public_path__ + "static/media/Rectangle.8adb183c.svg";